// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payout-settings-tab {
  padding: 0;
}

.payout-settings-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  gap: 12px;
  color: var(--text-secondary);
}

.payout-settings-loading .spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Header */
.payout-header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 24px;
}

.payout-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: var(--grad-primary);
  border-radius: var(--r-md);
  color: white;
}

.payout-header-text h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 4px 0;
}

.payout-header-text p {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0;
}

/* Mode Indicator */
.payout-mode-indicator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-left: auto;
}

.payout-mode-indicator.test {
  background: var(--brand-100);
  color: var(--brand-600);
  border: 1px solid var(--brand-100);
}

.payout-mode-indicator.live {
  background: var(--ok-soft);
  color: var(--ok);
  border: 1px solid var(--ok-soft);
}

/* Message Banner */
.payout-settings-tab .message-banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 0.875rem;
}

.payout-settings-tab .message-banner.success {
  background: var(--ok-soft);
  border: 1px solid var(--ok-soft);
  color: var(--ok);
}

.payout-settings-tab .message-banner.error {
  background: var(--err-soft);
  border: 1px solid var(--err-soft);
  color: var(--err);
}

.payout-settings-tab .message-banner .close-btn {
  margin-left: auto;
  background: none;
  border: none;
  color: inherit;
  font-size: 1.25rem;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.payout-settings-tab .message-banner .close-btn:hover {
  opacity: 1;
}

/* Form */
.payout-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .payout-form {
    grid-template-columns: 1fr;
  }
}

.payout-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.payout-form .form-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
}

.payout-form .label-icon {
  flex-shrink: 0;
}

.payout-form .label-icon.green {
  color: var(--ok);
}

.payout-form .label-icon.orange {
  color: var(--warn);
}

/* Input with prefix/suffix */
.input-with-prefix,
.input-with-suffix {
  position: relative;
  display: flex;
  align-items: center;
}

.input-prefix,
.input-suffix {
  position: absolute;
  color: var(--text-muted);
  font-size: 0.875rem;
  pointer-events: none;
}

.input-prefix {
  left: 14px;
}

.input-suffix {
  right: 14px;
}

.input-with-prefix input {
  padding-left: 32px;
}

.input-with-suffix input {
  padding-right: 32px;
}

.payout-form input {
  width: 100%;
  padding: 12px 14px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  font-size: 0.875rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.payout-form input:focus {
  outline: none;
  border-color: var(--brand-600);
  box-shadow: 0 0 0 3px var(--brand-100);
}

.payout-form input.error {
  border-color: var(--err);
}

.payout-form input::placeholder {
  color: var(--text-muted);
}

/* Remove number input spinners */
.payout-form input[type="number"]::-webkit-outer-spin-button,
.payout-form input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.payout-form input[type="number"] {
  -moz-appearance: textfield;
}

.error-text {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.75rem;
  color: var(--err);
}

.help-text {
  font-size: 0.75rem;
  color: var(--text-muted);
}

/* Example Calculation */
.example-calculation {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.example-calculation h4 {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 12px 0;
}

.calculation-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.calculation-content p {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin: 0;
}

.calculation-content strong {
  color: var(--text-primary);
}

.fee-amount {
  color: var(--warn);
  font-weight: 600;
}

.receive-amount {
  color: var(--ok);
  font-weight: 600;
}

/* Actions */
.payout-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid var(--border-color);
}

.payout-actions .btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: var(--grad-primary);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.2s;
}

.payout-actions .btn-primary:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.payout-actions .btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.payout-actions .btn-primary .spinning {
  animation: spin 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/PayoutSettingsTab.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;;EAEE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".payout-settings-tab {\n  padding: 0;\n}\n\n.payout-settings-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 48px;\n  gap: 12px;\n  color: var(--text-secondary);\n}\n\n.payout-settings-loading .spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Header */\n.payout-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--border-color);\n  margin-bottom: 24px;\n}\n\n.payout-header-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background: var(--grad-primary);\n  border-radius: var(--r-md);\n  color: white;\n}\n\n.payout-header-text h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 4px 0;\n}\n\n.payout-header-text p {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n/* Mode Indicator */\n.payout-mode-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-left: auto;\n}\n\n.payout-mode-indicator.test {\n  background: var(--brand-100);\n  color: var(--brand-600);\n  border: 1px solid var(--brand-100);\n}\n\n.payout-mode-indicator.live {\n  background: var(--ok-soft);\n  color: var(--ok);\n  border: 1px solid var(--ok-soft);\n}\n\n/* Message Banner */\n.payout-settings-tab .message-banner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  font-size: 0.875rem;\n}\n\n.payout-settings-tab .message-banner.success {\n  background: var(--ok-soft);\n  border: 1px solid var(--ok-soft);\n  color: var(--ok);\n}\n\n.payout-settings-tab .message-banner.error {\n  background: var(--err-soft);\n  border: 1px solid var(--err-soft);\n  color: var(--err);\n}\n\n.payout-settings-tab .message-banner .close-btn {\n  margin-left: auto;\n  background: none;\n  border: none;\n  color: inherit;\n  font-size: 1.25rem;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.payout-settings-tab .message-banner .close-btn:hover {\n  opacity: 1;\n}\n\n/* Form */\n.payout-form {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 24px;\n  margin-bottom: 24px;\n}\n\n@media (max-width: 768px) {\n  .payout-form {\n    grid-template-columns: 1fr;\n  }\n}\n\n.payout-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.payout-form .form-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\n.payout-form .label-icon {\n  flex-shrink: 0;\n}\n\n.payout-form .label-icon.green {\n  color: var(--ok);\n}\n\n.payout-form .label-icon.orange {\n  color: var(--warn);\n}\n\n/* Input with prefix/suffix */\n.input-with-prefix,\n.input-with-suffix {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-prefix,\n.input-suffix {\n  position: absolute;\n  color: var(--text-muted);\n  font-size: 0.875rem;\n  pointer-events: none;\n}\n\n.input-prefix {\n  left: 14px;\n}\n\n.input-suffix {\n  right: 14px;\n}\n\n.input-with-prefix input {\n  padding-left: 32px;\n}\n\n.input-with-suffix input {\n  padding-right: 32px;\n}\n\n.payout-form input {\n  width: 100%;\n  padding: 12px 14px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.payout-form input:focus {\n  outline: none;\n  border-color: var(--brand-600);\n  box-shadow: 0 0 0 3px var(--brand-100);\n}\n\n.payout-form input.error {\n  border-color: var(--err);\n}\n\n.payout-form input::placeholder {\n  color: var(--text-muted);\n}\n\n/* Remove number input spinners */\n.payout-form input[type=\"number\"]::-webkit-outer-spin-button,\n.payout-form input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.payout-form input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.error-text {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.75rem;\n  color: var(--err);\n}\n\n.help-text {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n/* Example Calculation */\n.example-calculation {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.example-calculation h4 {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 12px 0;\n}\n\n.calculation-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.calculation-content p {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin: 0;\n}\n\n.calculation-content strong {\n  color: var(--text-primary);\n}\n\n.fee-amount {\n  color: var(--warn);\n  font-weight: 600;\n}\n\n.receive-amount {\n  color: var(--ok);\n  font-weight: 600;\n}\n\n/* Actions */\n.payout-actions {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid var(--border-color);\n}\n\n.payout-actions .btn-primary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 24px;\n  background: var(--grad-primary);\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.2s;\n}\n\n.payout-actions .btn-primary:hover:not(:disabled) {\n  opacity: 0.9;\n  transform: translateY(-1px);\n}\n\n.payout-actions .btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.payout-actions .btn-primary .spinning {\n  animation: spin 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
